export const home_pg_url = "/";

//serves as login and home url with url parameters
export const cari_home_pg_url = "/cari";

export const cari_app_form_pg_1_url = "/cari/app_form/1";

export const cari_app_form_pg_2_url = "/cari/app_form/2";

export const cari_app_form_pg_3_url = "/cari/app_form/3";

export const cari_app_form_pg_4_url = "/cari/app_form/4";

export const cari_app_form_pg_submitted_url = "/cari/app_form/submitted";

export const cari_app_form_url = "/cari/app_form";

export const cari_reference_url = "/cari/reference";

export const cari_reference_submitted_url = "/cari/reference/submitted";

export const cari_app_form_consent_url = "/cari/app_form/consent";

export const cari_create_account_url = "/cari/create_account";

//production demo nav bar
export const cari_logged_in_production_nav_bar = [
    {
        label: "Home",
        url: cari_home_pg_url,
    },
]

// nav bar routes: //debug TODO remove
export const cari_app_form_nav_bar_option_urls = [
    {
        label: "Home",
        url: home_pg_url,
    },
    {
        label: "Cari Home",
        url: cari_home_pg_url,
    },
    {
        label: "Cari Form - 1",
        url: cari_app_form_pg_1_url,
    },
    {
        label: "Cari Form - 2",
        url: cari_app_form_pg_2_url,
    },
    {
        label: "Cari Form - 3",
        url: cari_app_form_pg_3_url,
    }, 
    {
        label: "Cari Form - 4",
        url: cari_app_form_pg_4_url,
    },
    {
        label: "Cari Form - Submitted",
        url: cari_app_form_pg_submitted_url,
    },
    {
        label: "Cari Reference",
        url: cari_reference_url + "/referenceId",
    },
    {
        label: "Cari Reference - Submitted",
        url: cari_reference_submitted_url,
    },
];

//logged in nav bar //debug TODO remove
export const cari_logged_in_nav_bar = [
    {
        label: "Cari Home",
        url: cari_home_pg_url,
    },
    {
        label: "Cari Form - 1",
        url: cari_app_form_pg_1_url,
    },
    {
        label: "Cari Form - 2",
        url: cari_app_form_pg_2_url,
    },
    {
        label: "Cari Form - 3",
        url: cari_app_form_pg_3_url,
    },
    {
        label: "Cari Form - 4",
        url: cari_app_form_pg_4_url,
    },
];

//external nav bar
//logged in nav bar
export const cari_external_nav_bar = [
    {
        label: "Cari Login",
        url: cari_home_pg_url,
    },
    {
        label: "Cari Reference",
        url: cari_reference_url + "/referenceId",
    },
    {
        label: "Cari Reference - Submitted",
        url: cari_reference_submitted_url,
    },
];



//setting server for api
const staging_cari_server = "https://staging.bus.sfu.ca";
const production_cari_server = "https://beedie.sfu.ca";
const development_cari_server = "https://dev.busdevw";

let cari_api_server;
if (process.env.REACT_APP_ENV === "development") {
    cari_api_server = development_cari_server;
} else if (process.env.REACT_APP_ENV === "staging") {
    cari_api_server = staging_cari_server;
} else {
    cari_api_server = production_cari_server;
}

//validate login session
export const cari_api_validate_user_login_session = cari_api_server + "/tracs_v3/api/cari/validateUserSession";

//home page
export const cari_api_load_home_url = cari_api_server + "/tracs_v3/api/cari/loadHome";

export const cari_api_load_outage_banner_url = cari_api_server + "/tracs_v3/api/cari/outageBanner";

//api base route
export const cari_api_base_url = cari_api_server + "/tracs_v3/api/cari";

//page creates consent page
export const cari_api_create_application_url = cari_api_server + "/tracs_v3/api/cari/createApplication";

export const cari_api_load_form_page_0_url = cari_api_server + "/tracs_v3/api/cari/loadPage0";


//form page loads
export const cari_api_load_form_page_1_url = cari_api_server + "/tracs_v3/api/cari/loadPage1";

export const cari_api_load_form_page_2_url = cari_api_server + "/tracs_v3/api/cari/loadPage2";

export const cari_api_load_form_page_3_url = cari_api_server + "/tracs_v3/api/cari/loadPage3";

export const cari_api_load_form_page_4_url = cari_api_server + "/tracs_v3/api/cari/loadPage4";

//page saves base url
export const cari_api_save_form_page_base_url = cari_api_server + "/tracs_v3/api/cari/savePage"; //just append 1,2,3,4 to save

//save docs comments
export const cari_api_save_doc_comments_url = cari_api_server + "/tracs_v3/api/cari/saveDocComments";

//save applicant new institution 
export const cari_api_add_applicant_new_institution_url = cari_api_server + "/tracs_v3/api/cari/addApplicantNewInstitution";

//save reference new institution 
export const cari_api_add_reference_new_institution_url = cari_api_server + "/tracs_v3/api/cari/addReferenceNewInstitution";


//submission api verify and submit application
export const cari_api_verify_application_url = cari_api_server + "/tracs_v3/api/cari/validateApplication";

export const cari_api_submit_application_url = cari_api_server + "/tracs_v3/api/cari/submitApplication";


//login api
//login existing user or create, verifiy passed in email
export const cari_api_auth_email_url = cari_api_server + "/tracs_v3/api/cari/authenticate";

export const cari_api_create_account_url = cari_api_server + "/tracs_v3/api/cari/createAccount";

//verifiy typed in auth code
export const cari_api_verify_login_url = cari_api_server + "/tracs_v3/api/cari/verifyLogin";

//references api
export const cari_api_load_reference_data_url = cari_api_server + "/tracs_v3/api/cari/loadReference";

export const cari_api_save_reference_data_url = cari_api_server + "/tracs_v3/api/cari/saveReference";

//file upload api
export const cari_api_upload_file_url = cari_api_server + "/tracs_v3/api/cari/uploadPage3File";

//file replace upload api
export const cari_api_replace_upload_file_url = cari_api_server + "/tracs_v3/api/cari/replaceUploadPage3File";

//file delete api
export const cari_api_delete_file_url = cari_api_server + 
"/tracs_v3/api/cari/deletePage3File";

//auto complete apis
export const cari_api_university_auto_complete_url = cari_api_server + "/tracs_v3/api/CARI_api/university_autocomplete/"

export const cari_api_country_auto_complete_url = cari_api_server + "/tracs_v3/api/CARI_api/country_autocomplete/"